// Formatea una fecha ISO como "DD/NombreDeMes/YYYY" (p. ej. "22/Mayo/2025")
// — usado en "Detalle de arrendamiento". `toLocaleString('es-MX', ...)`
// devuelve el mes en minúsculas, así que se capitaliza a mano.
export const formatDateLong = (isoString: string): string => {
  if (!isoString) return ''

  const date = new Date(isoString)
  if (isNaN(date.getTime())) return ''

  const [day, month, year] = date
    .toLocaleDateString('es-MX', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      timeZone: 'America/Mexico_City',
    })
    .split(/ de /)

  const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1)

  return `${day}/${capitalizedMonth}/${year}`
}
